import { OBJ_CODE_PATH } from '@constants'

export const getObjectCodeUrl = (objectCode: string) => `${OBJ_CODE_PATH}/${objectCode}`
